import { render } from "./BounsPage.vue?vue&type=template&id=ffb7465e"
import script from "./BounsPage.vue?vue&type=script&lang=js"
export * from "./BounsPage.vue?vue&type=script&lang=js"

import "./BounsPage.vue?vue&type=style&index=0&id=ffb7465e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__